import ConnectApi, { ConnectUser } from "../api/ConnectApi"

interface ConnectApiProps {
  connectProjectId?: string
  connectProjectOrigin?: string
}

export const getProjectUsers = async (props: ConnectApiProps): Promise<ConnectUser[]> => {
  const { connectProjectId, connectProjectOrigin } = props
  if (!connectProjectId || !connectProjectOrigin) {
    return []
  } else {
    const usersByTidUuid = await new ConnectApi(connectProjectOrigin).getConnectProjectUsers(connectProjectId)
    return usersByTidUuid
  }
}

export const getLoggedInUserProjectRole = async (props: ConnectApiProps): Promise<string> => {
  const { connectProjectId, connectProjectOrigin } = props
  if (!connectProjectId || !connectProjectOrigin) {
    throw new Error("Connect project ID and origin needed to get logged in user role")
  } else {
    const api = new ConnectApi(connectProjectOrigin)
    const projectRoles = await api.getLoggedInUserProjectRoles()
    const projectRole = projectRoles.find((p: any) => p.id === connectProjectId)
    if (projectRole) {
      return projectRole.role
    } else {
      throw new Error(`User has no role in project ${connectProjectId}`)
    }
  }
}

export const getUserGroups = async (props: ConnectApiProps): Promise<{ id: string; name: string }[]> => {
  const { connectProjectId, connectProjectOrigin } = props
  if (!connectProjectId || !connectProjectOrigin) {
    return []
  } else {
    const usersByTidUuid = await new ConnectApi(connectProjectOrigin).getConnectProjectUserGroups(connectProjectId)
    return usersByTidUuid
  }
}

export const getUsersfromGroups = async (connectProjectGroupIds: string[]) => {
  return Promise.all(
    connectProjectGroupIds.map((groupId: string) => {
      const users = new ConnectApi().getUsersInAGroup(groupId)
      return users
    })
  )
}
